import transformTextToSlug from '../transformTextToSlug'
import { shouldUseInLocationFromSearchbar } from '../../domain/search/shouldUseInLocationFromSearchbar'
import refineSearchStateByLocations from '../../domain/search/refineSearchStateByLocations'
import refineSearchByGeolocation from '../../domain/search/refineSearchByGeolocation'
import { COUNTRY_NAMES_BY_CODE } from '../../domain/location/constants'

const fetchCoordinatesAndRefineSearch = async ({
  googlePlaceId,
  locationName,
  locationType,
  simpleLocationName
}) => {
  const slug = transformTextToSlug(
    COUNTRY_NAMES_BY_CODE[simpleLocationName] || simpleLocationName
  )

  const fetchGeocodeResponse = fetch('/api/locationCoordinates', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ googlePlaceId })
  })

  const fetchLocationPromise = fetch(`/api/location/${slug}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  const [geocodeResponse, locationResponse] = await Promise.all([
    fetchGeocodeResponse,
    fetchLocationPromise
  ])

  const geoLocation = await geocodeResponse.json()
  const location = (await locationResponse.json())?.data

  const { address_components, types } = geoLocation

  if (shouldUseInLocationFromSearchbar({ address_components, types })) {
    return refineSearchStateByLocations({
      simpleLocationName,
      locationName,
      locationType
    })
  }

  return refineSearchByGeolocation({
    locationName,
    locationType,
    geoLocation,
    location
  })
}

export default fetchCoordinatesAndRefineSearch
